/** Hero tile spans both columns; remaining media render as square tiles. */
/** Both paint from the 600px `main` list; the 1000px variant backs the hover zoom. */
export const HERO_IMAGE_SIZE = '600';
export const TILE_IMAGE_SIZE = '600';

/** Size the magnifier enlarges to, and the intrinsic dimensions of that variant. */
export const ZOOM_IMAGE_SIZE = '1000';
export const ZOOM_INTRINSIC_SIZE = 1000;

/** Intrinsic pixel dimensions used for width/height attributes to reserve layout space (CLS). */
export const HERO_INTRINSIC_WIDTH = 1000;
export const HERO_INTRINSIC_HEIGHT = 850;
export const TILE_INTRINSIC_WIDTH = 600;
export const TILE_INTRINSIC_HEIGHT = 600;

/** Hero + 4 tiles are rendered above the fold before the "show more" affordance. */
export const DEFAULT_VISIBLE_TILE_COUNT = 5;

export const HERO_ASPECT_RATIO = '10 / 8.5';
export const TILE_ASPECT_RATIO = '1 / 1';

export const GALLERY_LABEL = 'Product Images';
